import React from "react";

const CountersAndWhyChooseUs = () => {
  return (
    <>
      {/* Why Choose Us */}
      <div className="why-sec-2" id="why-sec">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xxl-6 col-xl-7 col-lg-9">
              <div className="title-area text-center">
                <h2 className="sec-title">Why Choose Our Urbania on Rent in Pune</h2>
                <p>
                  We provide premium Force Urbania rental services in Pune with
                  a strong focus on comfort, safety, punctuality, and customer
                  satisfaction for every journey.
                </p>
              </div>
            </div>
          </div>

          <div className="row gy-30 align-items-center">
            {/* Card 1 */}
            <div className="col-lg-6 col-xl-3">
              <div className="why-card-2">
                <div className="box-icon">
                  <img src="/img/icon/why_card_2_1.svg" alt="Wide Fleet" />
                </div>
                <div className="box-content">
                  <h3 className="box-title">Well-Maintained Urbania Fleet</h3>
                  <p className="box-text">
                    We offer 14, 17, and luxury Force Urbania vehicles that are
                    clean, spacious, and regularly serviced for a smooth travel
                    experience.
                  </p>
                </div>
              </div>
            </div>

            {/* Card 2 */}
            <div className="col-lg-6 col-xl-3">
              <div className="why-card-2">
                <div className="box-icon">
                  <img src="/img/icon/why_card_2_2.svg" alt="Best Pricing" />
                </div>
                <div className="box-content">
                  <h3 className="box-title">Best Price Urbania Rental in Pune</h3>
                  <p className="box-text">
                    Get transparent and competitive pricing for Urbania on rent
                    in Pune with no hidden charges and flexible rental packages.
                  </p>
                </div>
              </div>
            </div>

            {/* Card 3 */}
            <div className="col-lg-6 col-xl-3">
              <div className="why-card-2">
                <div className="box-icon">
                  <img src="/img/icon/why_card_2_3.svg" alt="Flexible Booking" />
                </div>
                <div className="box-content">
                  <h3 className="box-title">Flexible Booking & Custom Trips</h3>
                  <p className="box-text">
                    Book Urbania for local Pune travel, outstation tours,
                    corporate events, weddings, airport transfers, and
                    pilgrimage trips.
                  </p>
                </div>
              </div>
            </div>

            {/* Card 4 */}
            <div className="col-lg-6 col-xl-3">
              <div className="why-card-2">
                <div className="box-icon">
                  <img src="/img/icon/why_card_2_4.svg" alt="Professional Driver" />
                </div>
                <div className="box-content">
                  <h3 className="box-title">Experienced & Verified Drivers</h3>
                  <p className="box-text">
                    Our professional drivers are trained, polite, route-aware,
                    and ensure safe, comfortable, and on-time journeys across
                    Pune and beyond.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CountersAndWhyChooseUs;
